interface ISparkVideosUrls {
  mainUrl: string
  qualities: {
    [key: number]: string
  }
  thumbnailUrl: string
  isVertical: boolean
}

interface IQualityOption {
  label: string
  value: string
  resolution: string
  bandwidth: number
}

const qualityMappings: { [key: number]: Omit<IQualityOption, 'value'> } = {
  480: {
    label: '480p',
    resolution: '854x480',
    bandwidth: 800000,
  },
  720: {
    label: '720p',
    resolution: '1280x720',
    bandwidth: 2800000,
  },
  1080: {
    label: '1080p',
    resolution: '1920x1080',
    bandwidth: 5000000,
  },
}

export function generateVideoQualityOptions(
  sparkVideosUrls: ISparkVideosUrls | null,
): IQualityOption[] {
  if (!sparkVideosUrls) return []

  const options: IQualityOption[] = [
    {
      label: 'Automático',
      value: sparkVideosUrls.mainUrl,
      resolution: 'auto',
      bandwidth: 0,
    },
  ]

  Object.entries(sparkVideosUrls.qualities).forEach(([resolution, url]) => {
    const resolutionNumber = parseInt(resolution)
    const qualityMapping = qualityMappings[resolutionNumber]

    if (qualityMapping) {
      options.push({
        ...qualityMapping,
        value: url,
      })
    }
  })

  return options.sort((a, b) => a.bandwidth - b.bandwidth)
}
